import { history } from '@umijs/max';
import { normalizeSuperAdminFlag, userCache } from '@/store/userInfo';
import { clearActiveApiKey } from './apiKey';

type SetInitialState = (updater: (state: any) => any) => void;

export const clearUserSession = () => {
  userCache.isSuperAdmin = normalizeSuperAdminFlag(userCache.isSuperAdmin);
  userCache.guid = '';
  userCache.token = '';
  userCache.username = '';
  userCache.userName = '';
  userCache.avatar = '';
  userCache.currentAppUuid = '';
  userCache.apps = [];
  userCache.permissions = [];
  userCache.permissionAppUuid = '';
  userCache.isSuperAdmin = 0;
  clearActiveApiKey();
  window.dispatchEvent(new Event('user-cache-update'));
};

export const redirectToLogin = (options?: {
  setInitialState?: SetInitialState;
  preserveRedirect?: boolean;
}) => {
  const { setInitialState, preserveRedirect = true } = options || {};

  if (setInitialState) {
    setInitialState((state) => ({
      ...state,
      currentUser: undefined,
      permissionRefreshKey: 0,
    }));
  }

  const { pathname, search } = window.location;
  const redirect = new URL(window.location.href).searchParams.get('redirect');

  if (window.location.pathname === '/login' || redirect) {
    return;
  }

  history.replace({
    pathname: '/login',
    ...(preserveRedirect
      ? {
          search: new URLSearchParams({
            redirect: pathname + search,
          }).toString(),
        }
      : {}),
  });
};

export const logoutToLogin = (options?: {
  setInitialState?: SetInitialState;
  preserveRedirect?: boolean;
}) => {
  clearUserSession();
  redirectToLogin(options);
};
